/* The gift card picture's behaviour (snippets/gift-card-art.liquid), the
   same wherever the card is shown:
   - press anywhere: it tips back towards the finger and bounces (a spring);
   - desktop with a mouse or trackpad: a gentle tilt and a light that follow
     the pointer;
   - data-gccard="control" cards are focusable; Enter or Space presses them;
   - nothing moves under prefers-reduced-motion.
   window.TOMSGiftCard lets a page change the card:
     TOMSGiftCard.set(card, { amount, forName, forWord, message, flip })
     TOMSGiftCard.arrive(card)   (a short swing-in, used after a jump link)
   Loaded once per page; repeat script tags do nothing. */
(function () {
  if (window.TOMSGiftCard) return;
  var mq = function (q) { return !!(window.matchMedia && window.matchMedia(q).matches); };
  var still = function () { return mq('(prefers-reduced-motion: reduce)'); };
  var fine = mq('(hover: hover) and (pointer: fine)');
  var MAX = 16, DEPTH = -34, TILT = 7, K = 260, DAMP = 11;

  function Spring(card) {
    var face = card.querySelector('.gccard__face');
    var st = { rx: 0, ry: 0, z: 0 }, vel = { rx: 0, ry: 0, z: 0 }, goal = { rx: 0, ry: 0, z: 0 };
    var running = false, last = 0, held = false;
    function render() {
      face.style.transform = 'translateZ(' + st.z.toFixed(2) + 'px) rotateX(' + st.rx.toFixed(2) + 'deg) rotateY(' + st.ry.toFixed(2) + 'deg)';
    }
    function tick(t) {
      var dt = Math.min(0.032, (t - last) / 1000 || 0.016);
      last = t;
      var moving = false;
      ['rx', 'ry', 'z'].forEach(function (k) {
        vel[k] += (-K * (st[k] - goal[k]) - DAMP * vel[k]) * dt;
        st[k] += vel[k] * dt;
        if (Math.abs(vel[k]) > 0.01 || Math.abs(st[k] - goal[k]) > 0.01) moving = true;
      });
      render();
      if (moving || held) requestAnimationFrame(tick);
      else {
        running = false; st = { rx: goal.rx, ry: goal.ry, z: goal.z }; render();
        if (!goal.rx && !goal.ry && !goal.z) face.style.transform = '';
      }
    }
    function go() { if (!running) { running = true; last = performance.now(); requestAnimationFrame(tick); } }
    function light(x, y) {
      face.style.setProperty('--px', ((x + 1) * 50) + '%');
      face.style.setProperty('--py', ((y + 1) * 50) + '%');
    }
    function at(e) {
      var r = face.getBoundingClientRect();
      return {
        x: Math.max(-1, Math.min(1, ((e.clientX - r.left) / r.width) * 2 - 1)),
        y: Math.max(-1, Math.min(1, ((e.clientY - r.top) / r.height) * 2 - 1))
      };
    }
    return {
      face: face,
      press: function (e) {
        var p = at(e);
        held = true;
        goal.ry = p.x * MAX; goal.rx = -p.y * MAX; goal.z = DEPTH;
        light(p.x, p.y);
        card.classList.add('is-pressed');
        go();
      },
      release: function () {
        if (!held) return;
        held = false;
        card.classList.remove('is-pressed');
        goal.rx = 0; goal.ry = 0; goal.z = 0;
        go();
      },
      tilt: function (e) {
        if (held) return;
        var p = at(e);
        goal.ry = p.x * TILT; goal.rx = -p.y * TILT; goal.z = 0;
        light(p.x, p.y);
        card.classList.add('is-tilting');
        go();
      },
      settle: function () {
        card.classList.remove('is-tilting');
        if (held) return;
        goal.rx = 0; goal.ry = 0; goal.z = 0;
        go();
      },
      kick: function (rx, ry, z) {
        st.rx += rx || 0; st.ry += ry || 0; st.z += z || 0;
        go();
      },
      spin: function (v) { vel.ry += v; go(); }
    };
  }

  function bind(card) {
    if (card.__gc || !card.querySelector('.gccard__face')) return card.__gc;
    var mode = card.getAttribute('data-gccard');
    var s = Spring(card);
    card.__gc = s;
    if (mode !== 'control' && mode !== 'decor') return s;

    card.addEventListener('pointerdown', function (e) {
      if (still() || (e.button && e.button !== 0)) return;
      if (mode === 'control') { try { card.setPointerCapture(e.pointerId); } catch (x) {} }
      s.press(e);
    });
    var up = function () { s.release(); };
    card.addEventListener('pointerup', up);
    card.addEventListener('pointercancel', function () { s.release(); });
    card.addEventListener('lostpointercapture', function () { s.release(); });

    if (fine) {
      /* the tilt follows the pointer over the card, or over the tile that
         holds it (data-gccard-host), so the whole tile feels alive */
      var host = card.closest('[data-gccard-host]') || card;
      host.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || still()) return;
        s.tilt(e);
      });
      host.addEventListener('pointerleave', function () { s.release(); s.settle(); });
    }

    if (mode === 'control') {
      card.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        if (still()) return;
        var r = s.face.getBoundingClientRect();
        s.press({ clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 });
        setTimeout(function () { s.release(); }, 140);
      });
    }
    return s;
  }

  function init(root) {
    (root || document).querySelectorAll('[data-gccard]').forEach(bind);
  }

  function pop(el) {
    if (!el || still()) return;
    el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop');
  }

  window.TOMSGiftCard = {
    init: init,
    /* opts: amount (text), forName, forWord, message, flip (true = the card
       turns a little and springs back), pop (default true when the amount
       changes) */
    set: function (card, o) {
      if (!card) return;
      o = o || {};
      var amt = card.querySelector('.gccard__amt');
      if (o.amount != null && amt && amt.textContent !== String(o.amount)) {
        amt.textContent = o.amount;
        if (o.pop !== false) pop(amt);
        if (o.flip && !still()) { var s = bind(card); if (s) s.spin(-320); }
      }
      var f = card.querySelector('.gccard__for');
      if (f && o.forName !== undefined) {
        var n = (o.forName || '').trim();
        f.hidden = !n;
        f.textContent = n ? (o.forWord || 'For') + ' ' + n : '';
      }
      var m = card.querySelector('.gccard__msg');
      if (m && o.message !== undefined) {
        var t = (o.message || '').trim();
        m.hidden = !t;
        m.textContent = t ? '“' + t + '”' : '';
      }
    },
    arrive: function (card) {
      if (!card || still()) return;
      var s = bind(card);
      card.classList.remove('is-arrive'); void card.offsetWidth; card.classList.add('is-arrive');
      if (s) s.kick(-24, 30, -80);
      setTimeout(function () { card.classList.remove('is-arrive'); }, 600);
    },
    pop: pop
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
